<template>
  <div
    v-if="brand === 'mcom'"
    class="lty-my-perks-point-item-info small-8 medium-12 large-12"
  >
    <div class="grid-x align-justify">
      <div class="lty-perks-head cell align-center align-middle padding-bottom-xs padding-top-xs small-3 medium-4 large-4">
        <h3>
          {{ props.title }}
        </h3>
      </div>
      <div class="grid-x cell small-9 medium-8 large-8 align-middle align-center grid-margin-x">
        <div class="small-4">&nbsp;</div>
        <div class="small-8 margin-bottom-xs padding-left-xs padding-right-xxl">
          <div class="small-12 margin-bottom-xxs small padding-left-s text-center">
            {{ PERKS_LIST.PERKS_TIER_WHEN_YOU_SHOP }}
          </div>
          <div class="small-12">
            <img
              :src="perksArrowImg"
              alt="Perks Arrow"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { brand, PERKS_LIST } from '../../config';
import perksArrowImg from '../../assets/images/perks-arrow.svg';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
});
</script>
